__turbopack_context__.v({
  "accentGlow": "HeroPointerBackdrop-module__IriOda__accentGlow",
  "backdrop": "HeroPointerBackdrop-module__IriOda__backdrop",
  "dotField": "HeroPointerBackdrop-module__IriOda__dotField",
  "primaryGlow": "HeroPointerBackdrop-module__IriOda__primaryGlow",
  "secondaryGlow": "HeroPointerBackdrop-module__IriOda__secondaryGlow",
});
